const isoDateTimePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:\d{2})$/;

const dateTimeFormatOptions: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
};

const dateTimeSearchFormatters = [
  new Intl.DateTimeFormat("ru-RU", dateTimeFormatOptions),
  new Intl.DateTimeFormat("en-GB", dateTimeFormatOptions),
] as const;

// This function generates a search text for a given Date object by formatting it
// using multiple locale-specific formatters and combining the results into a single string.
// This allows for broader matching of date-time values in column filters, as it includes both dot and slash date formats.
export const getSearchTextFromDate = (value: Date): string => {
  return [...new Set(dateTimeSearchFormatters.map((formatter) => formatter.format(value)))].join(
    " "
  );
};

export const isIsoDateTimeString = (value: string): boolean => isoDateTimePattern.test(value);

export const getDateFromIsoString = (value: string): Date | null => {
  const dateValue = new Date(value);

  if (Number.isNaN(dateValue.getTime())) {
    return null;
  }

  return dateValue;
};
